<script setup lang="ts">
defineProps<{
  title?: string
  description?: string
  buttonLabel?: string
  to?: string
}>()

const stars = Array.from({ length: 40 }, () => ({
  top: `${Math.random() * 100}%`,
  left: `${Math.random() * 100}%`,
  size: Math.random() * 1.5 + 0.5,
  duration: Math.random() * 3 + 2,
  delay: Math.random() * 5
}))

const discordIcon = 'http://localhost:3845/assets/20a85712e7b305c173450d03fb15dd6f4e5984a0.png'
const buttonVector = 'http://localhost:3845/assets/f212477a1e4c06f187ca77efd10be55dc759795c.svg'
</script>

<template>
  <div class="relative overflow-hidden rounded-[2rem] bg-[#040907] backdrop-blur-[22px] border border-white/5 p-12 md:px-16 md:py-12">
    <!-- Mesh Gradient Background -->
    <div class="absolute -right-32 top-1/2 -translate-y-1/2 w-[458px] h-[706px] bg-[#040907] blur-[87px] opacity-50 pointer-events-none" />

    <!-- Top Blue Glow -->
    <div class="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent" />

    <div class="relative z-10 flex flex-col md:flex-row items-center justify-between gap-12">
      <div class="flex-1 space-y-8 text-center md:text-left">
        <div class="space-y-6">
          <h2 class="text-xl font-normal font-supercell uppercase leading-tight text-white">
            {{ title || 'Join our Discord Server' }}
          </h2>
          <p class="text-base text-white/80 font-sans tracking-[0.16px] leading-[22px] max-w-[507px]">
            {{ description || 'Talk with the community! Become an official member of the Velara Hosting community by joining our public Discord server.' }}
          </p>
        </div>

        <div class="flex justify-center md:justify-start">
          <NuxtLink
            :to="to || 'https://discord.gg/velara'"
            class="group relative inline-flex items-center justify-center w-[256px] h-[60px] text-white font-bold transition-all duration-300"
          >
            <!-- SVG Button Background -->
            <div class="absolute inset-0 z-0">
              <img
                :src="buttonVector"
                alt=""
                class="w-full h-full object-contain"
              >
            </div>

            <!-- Animated Stars/Dots -->
            <div class="absolute inset-x-6 inset-y-2 pointer-events-none overflow-hidden z-1">
              <div
                v-for="(star, i) in stars"
                :key="i"
                class="absolute rounded-full bg-white animate-pulse-slow"
                :style="{
                  top: star.top,
                  left: star.left,
                  width: `${star.size}px`,
                  height: `${star.size}px`,
                  opacity: 0.8,
                  animationDuration: `${star.duration}s`,
                  animationDelay: `${star.delay}s`
                }"
              />
            </div>

            <div class="relative z-10 flex items-center gap-2">
              <span class="text-lg font-sans">{{ buttonLabel || 'Accept Invite' }}</span>
              <UIcon
                name="i-lucide-chevron-right"
                class="w-5 h-5 transition-transform group-hover:translate-x-1"
              />
            </div>
          </NuxtLink>
        </div>
      </div>

      <!-- 3D Discord Logo -->
      <div class="relative w-64 h-64 md:w-[512px] md:h-[512px] flex items-center justify-center shrink-0 -my-32 md:-mr-16">
        <img
          :src="discordIcon"
          alt="Discord"
          class="w-full h-full object-contain mix-blend-lighten"
        >
        <div class="absolute inset-0 bg-[#5865f2] mix-blend-hue pointer-events-none rounded-full blur-3xl opacity-20" />
      </div>
    </div>
  </div>
</template>

<style scoped>
@keyframes pulse-slow {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
}

.animate-pulse-slow {
  animation: pulse-slow 3s infinite ease-in-out;
}
</style>
